<template>
    <formulateForm
        v-slot="{ isLoading, hasErrors }"
        v-model="formData"
        name="profileForm"
        @submit="handleSubmit"
    >
        <b-card>
            <h2>Edição do perfil</h2>

            <b-row class="match-height">
                <b-col cols="12">
                    <formulateInput
                        label="Nome"
                        name="name"
                        type="text"
                        validation="required|max:255,length"
                    />
                    <formulateInput
                        label="E-mail"
                        name="email"
                        type="text"
                        validation="required|email"
                    />
                    <formulateInput
                        label="Senha"
                        name="password"
                        type="password"
                    />
                    <formulateInput
                        label="Confirme a senha"
                        name="password_confirmation"
                        type="password"
                    />
                </b-col>
            </b-row>

            <formulateErrors />
            <bAlert :show="showSuccessMessage" variant="success">
                <div class="alert-body">
                    <span>Perfil atualizado com sucesso!</span>
                </div>
            </bAlert>
            <formulateInput
                :disabled="hasErrors || isLoading"
                :label="isLoading ? 'Atualizando...' : 'Atualizar'"
                inputClass="btn btn-primary"
                type="submit"
            />
        </b-card>
    </formulateForm>
</template>

<script>
import { BAlert, BCard, BCol, BRow } from "bootstrap-vue"

export default {
    components: {
        BAlert,
        BRow,
        BCol,
        BCard,
    },
    data() {
        return {
            formData: {},
            showSuccessMessage: false,
        }
    },
    created() {
        this.getProfile()
    },
    methods: {
        async getProfile() {
            const response = await this.$http.get("/api/profile")
            this.formData = { ...response.data.data }
        },
        async handleSubmit() {
            try {
                await this.$http.post("/api/profile/update", {
                    ...this.formData,
                })
                this.showSuccessMessage = true
                this.formData.password = ""
                this.formData.password_confirmation = ""
            } catch (e) {
                this.$formulate.handle(e, "profileForm")
            }
        },
    },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-profile.scss";
</style>
